module.exports = __webpack_public_path__ + "static/media/course7.52e0feb4.jpg";